export const removeFileCase = async (id: string): Promise<void> => {
  try {
    const response = await fetch('/api/file-delete/' + id, {
      method: 'DELETE',
    });
    return response.json();
  } catch (error) {
    console.log(error);
  }
};
